import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import Container from 'components/Container';

interface ImageCoverPageProps {
  imgSrc?: string;
  children: ReactNode;
}

export function ImageCoverPage({ imgSrc, children }: ImageCoverPageProps) {
  const theme = useTheme();
  return (
    <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
      <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} position={'relative'}>
        <Box width={1} order={{ xs: 2, md: 1 }} display={'flex'} alignItems={'center'}>
          <Container>{children}</Container>
        </Box>
        <Box
          sx={{
            flex: { xs: '0 0 100%', md: '0 0 50%' },
            position: 'relative',
            maxWidth: { xs: '100%', md: '50%' },
            order: { xs: 1, md: 2 },
            minHeight: { xs: 'auto', md: 'calc(100vh - 58px)' },
          }}
        >
          <Box
            sx={{
              width: { xs: 1, md: '50vw' },
              height: '100%',
              position: 'relative',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  left: '0%',
                  width: 1,
                  height: 1,
                  position: { xs: 'relative', md: 'absolute' },
                  clipPath: {
                    xs: 'none',
                    md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                  },
                  shapeOutside: {
                    xs: 'none',
                    md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                  },
                }}
              >
                <Box
                  sx={{
                    height: { xs: 'auto', md: 1 },
                    '& img': {
                      objectFit: 'cover',
                    },
                  }}
                >
                  <Box
                    component={'img'}
                    loading="lazy"
                    src={imgSrc}
                    height={{ xs: 'auto', md: 1 }}
                    maxHeight={{ xs: 300, md: 1 }}
                    width={1}
                    maxWidth={1}
                    sx={{
                      filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default ImageCoverPage;
